'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactJss = require('react-jss');

var _reactJss2 = _interopRequireDefault(_reactJss);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = require('./styles.js');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Row(_ref) {
  var _cn;

  var classes = _ref.classes,
      classNameCustom = _ref.className,
      style = _ref.style,
      children = _ref.children,
      ComponentClass = _ref.componentClass,
      reverse = _ref.reverse,
      xsStart = _ref.xsStart,
      smStart = _ref.smStart,
      mdStart = _ref.mdStart,
      lgStart = _ref.lgStart,
      xsCenter = _ref.xsCenter,
      smCenter = _ref.smCenter,
      mdCenter = _ref.mdCenter,
      lgCenter = _ref.lgCenter,
      xsEnd = _ref.xsEnd,
      smEnd = _ref.smEnd,
      mdEnd = _ref.mdEnd,
      lgEnd = _ref.lgEnd,
      xsTop = _ref.xsTop,
      smTop = _ref.smTop,
      mdTop = _ref.mdTop,
      lgTop = _ref.lgTop,
      xsMiddle = _ref.xsMiddle,
      smMiddle = _ref.smMiddle,
      mdMiddle = _ref.mdMiddle,
      lgMiddle = _ref.lgMiddle,
      xsBottom = _ref.xsBottom,
      smBottom = _ref.smBottom,
      mdBottom = _ref.mdBottom,
      lgBottom = _ref.lgBottom,
      xsAround = _ref.xsAround,
      smAround = _ref.smAround,
      mdAround = _ref.mdAround,
      lgAround = _ref.lgAround,
      xsBetween = _ref.xsBetween,
      smBetween = _ref.smBetween,
      mdBetween = _ref.mdBetween,
      lgBetween = _ref.lgBetween;

  var className = (0, _classnames2.default)((_cn = {}, _defineProperty(_cn, classes.row, true), _defineProperty(_cn, classes.reverse, reverse), _defineProperty(_cn, classes['xs-start'], xsStart), _defineProperty(_cn, classes['sm-start'], smStart), _defineProperty(_cn, classes['md-start'], mdStart), _defineProperty(_cn, classes['lg-start'], lgStart), _defineProperty(_cn, classes['xs-center'], xsCenter), _defineProperty(_cn, classes['sm-center'], smCenter), _defineProperty(_cn, classes['md-center'], mdCenter), _defineProperty(_cn, classes['lg-center'], lgCenter), _defineProperty(_cn, classes['xs-end'], xsEnd), _defineProperty(_cn, classes['sm-end'], smEnd), _defineProperty(_cn, classes['md-end'], mdEnd), _defineProperty(_cn, classes['lg-end'], lgEnd), _defineProperty(_cn, classes['xs-top'], xsTop), _defineProperty(_cn, classes['sm-top'], smTop), _defineProperty(_cn, classes['md-top'], mdTop), _defineProperty(_cn, classes['lg-top'], lgTop), _defineProperty(_cn, classes['xs-middle'], xsMiddle), _defineProperty(_cn, classes['sm-middle'], smMiddle), _defineProperty(_cn, classes['md-middle'], mdMiddle), _defineProperty(_cn, classes['lg-middle'], lgMiddle), _defineProperty(_cn, classes['xs-bottom'], xsBottom), _defineProperty(_cn, classes['sm-bottom'], smBottom), _defineProperty(_cn, classes['md-bottom'], mdBottom), _defineProperty(_cn, classes['lg-bottom'], lgBottom), _defineProperty(_cn, classes['xs-around'], xsAround), _defineProperty(_cn, classes['sm-around'], smAround), _defineProperty(_cn, classes['md-around'], mdAround), _defineProperty(_cn, classes['lg-around'], lgAround), _defineProperty(_cn, classes['xs-between'], xsBetween), _defineProperty(_cn, classes['sm-between'], smBetween), _defineProperty(_cn, classes['md-between'], mdBetween), _defineProperty(_cn, classes['lg-between'], lgBetween), _cn), classNameCustom);

  return _react2.default.createElement(
    ComponentClass,
    { className: className, style: style },
    children
  );
}

Row.propTypes = {
  classes: _propTypes2.default.object,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  children: _propTypes2.default.node,
  componentClass: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string]),

  reverse: _propTypes2.default.bool,

  xsStart: _propTypes2.default.bool,
  smStart: _propTypes2.default.bool,
  mdStart: _propTypes2.default.bool,
  lgStart: _propTypes2.default.bool,

  xsCenter: _propTypes2.default.bool,
  smCenter: _propTypes2.default.bool,
  mdCenter: _propTypes2.default.bool,
  lgCenter: _propTypes2.default.bool,

  xsEnd: _propTypes2.default.bool,
  smEnd: _propTypes2.default.bool,
  mdEnd: _propTypes2.default.bool,
  lgEnd: _propTypes2.default.bool,

  xsTop: _propTypes2.default.bool,
  smTop: _propTypes2.default.bool,
  mdTop: _propTypes2.default.bool,
  lgTop: _propTypes2.default.bool,

  xsMiddle: _propTypes2.default.bool,
  smMiddle: _propTypes2.default.bool,
  mdMiddle: _propTypes2.default.bool,
  lgMiddle: _propTypes2.default.bool,

  xsBottom: _propTypes2.default.bool,
  smBottom: _propTypes2.default.bool,
  mdBottom: _propTypes2.default.bool,
  lgBottom: _propTypes2.default.bool,

  xsAround: _propTypes2.default.bool,
  smAround: _propTypes2.default.bool,
  mdAround: _propTypes2.default.bool,
  lgAround: _propTypes2.default.bool,

  xsBetween: _propTypes2.default.bool,
  smBetween: _propTypes2.default.bool,
  mdBetween: _propTypes2.default.bool,
  lgBetween: _propTypes2.default.bool
};

Row.defaultProps = {
  componentClass: 'div'
};

exports.default = (0, _reactJss2.default)(_styles2.default)(Row);


//////////////////
// WEBPACK FOOTER
// ../dist/row/index.js
// module id = 126
// module chunks = 0